<template>
  <vs-popup id="newStockTransferModal" fullscreen class="holamundo" title="Yeni Stok Transferi" :active.sync="isActive"
            v-esc="escape">
    <vs-row vs-type="flex" vs-w="12">
      <vs-row vs-type="flex" vs-w="12" class="mb-2 sale-box-shadow p-2" vs-justify="space-between" vs-align="center">
        <vs-popup class="holamundo" :title="date + ' Devrini Kaydet'"
                  :active.sync="isUpdateConfirmActive" v-esc="escapeSubmit">
          <vs-row vs-type="flex" vs-w="12">
            <p>Bu Devir İşlemlemini Gerçekleştirmek İstediğinize Eminmisiniz ? Bu İşlem Geri Alınamaz ya da
              Güncellenemez !
            </p>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
            <vs-button type="gradient" color="danger" @click="isUpdateConfirmActive = false">Vazgeç</vs-button>
            <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-save"
                       @click="submitData(true);isUpdateConfirmActive = false">
              Kaydet
            </vs-button>
          </vs-row>
        </vs-popup>
        <vs-col vs-type="flex" class="w-auto" vs-align="center">
        <span class="text-medium-small2 bold text-primary">
          {{ date }}
        </span>
          <span v-if="hasWaitingForApprove" class="text-small weight-600 text-shadow text-warning ml-2">
            Girilen Son Devir Geç Yapılmış ve Merkez Onayı Bekliyor !
        </span>
          <span v-else-if="day < 3" class="text-small weight-600 text-shadow text-warning ml-2">
            {{
              $isCenterBranch ? 'Bu Devir Gecikmeli Girilmiştir ' : 'Stok Devri Geç Yapıldı Olarak Kayıt Edilip Merkeze Onayına Sunulacaktır !'
            }}
        </span>
        </vs-col>
        <vs-col v-if="!transferId && !hasWaitingForApprove" vs-type="flex" vs-align="center" class="w-auto">
          <vs-button id="emptyStocksExel" :disabled="newListWithStocks.length == 0" class="mr-2"
                     @click="getEmptyStocksExcel"
                     icon-pack="feather" icon="icon-download" color="primary">
          </vs-button>
          <vs-button id="saveTransfer" :disabled="newListWithStocks.length == 0" @click="submitData(false)"
                     icon-pack="feather" icon="icon-save" color="success">
            Kaydet
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row id="newTransfer" class="sale-box-shadow p-2 overflow-y-auto" vs-type="block" vs-w="12"
              v-if="newListWithStocks.length > 0">
        <vs-row vs-type="flex" class="px-2" vs-w="12" vs-justify="flex-start" vs-align="center">
          <vs-col vs-type="block" :vs-w="$isCenterBranch() ? 4 : 4">
            <div class="w-full d-flex align-center">
              <span class="pr-2 weight-600 text-primary text-medium-small">
                Stok Adı
              </span>
              <vs-button @click="isFilterOpen = !isFilterOpen;" type="line" class="border-none pl-0"
                         :color="stockNameFilter != null && stockNameFilter.length > 0 ? 'warning' : 'primary'"
                         icon-pack="feather"
                         icon="icon-search"/>
            </div>
            <div class="w-full d-flex align-center" v-show="isFilterOpen">
              <vs-input @input="setFilter" v-model="stockNameFilter" placeholder="Stok İsmi Ara"
                        class="stock-order-filter-input bg-white text-dark weight-600 w-64 text-small" size="small"/>
              <vs-button class="ml-2" @click="isFilterOpen = !isFilterOpen; stockNameFilter = '';setFilter('')"
                         size="small" radius color="danger"
                         icon-pack="feather" icon="icon-x"/>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" v-if="!$isCenterBranch()">
          <span class="w-full px-2 weight-600 text-primary text-medium-small text-center">
            Stok Kategorisi
          </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" v-if="$isCenterBranch()">
          <span class="w-full px-2 weight-600 text-primary text-medium-small text-center">
            Sistemdeki Miktar
          </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2">
          <span class="w-full px-2 weight-600 text-primary text-medium-small text-center">
            Stok Sayımı
          </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2">
          <span class="w-full px-2 weight-600 text-primary text-medium-small text-center">
            Birim
          </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" v-if="$isCenterBranch()">
          <span class="w-full pl-2 weight-600 text-primary text-medium-small text-center">
            Fark
          </span>
          </vs-col>
        </vs-row>
        <vs-divider class="mb-0 mt-2 bold" color="primary"/>
        <vs-row vs-type="block" vs-w="12">
          <vs-row id="newTransferEntry" vs-type="flex" vs-w="12" v-for="(entry,index) in filteredList" :key="index"
                  class="ml-1 py-2" vs-justify="space-between" vs-align="center">
            <vs-col vs-type="flex" :vs-w="$isCenterBranch() ? 4 : 4">
          <span class="w-full pr-2 weight-600 text-smaller">
            {{ entry.stock.rawMaterial.name }}
          </span>
            </vs-col>
            <vs-col vs-type="flex" vs-w="4" v-if="!$isCenterBranch()">
          <span class="w-full pr-2 weight-600 text-smaller">
            {{ entry.stock.rawMaterial.rawMaterialCategoryName }}
          </span>
            </vs-col>
            <vs-col vs-type="flex" vs-w="2" v-if="$isCenterBranch()">
          <span class="w-full weight-600 px-2 text-smaller text-center">
            {{ entry.originQuantity }}
          </span>
            </vs-col>
            <vs-col vs-type="block" vs-w="2">
              <vs-input :disabled="hasWaitingForApprove || transferId" :name="(index+1)+'.Sayım'"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
                        v-model="entry.currentLeft" class="w-full bg-white" size="small"/>
              <span class="text-danger text-sm"
                    v-show="errors.has((index+1)+'.Sayım')">{{ errors.first((index + 1) + '.Sayım') }}</span>
            </vs-col>
            <vs-col vs-type="flex" vs-w="2">
          <span class="w-full weight-600 px-2 text-smaller text-center">
            {{ entry.stock.unit.name }}
          </span>
            </vs-col>
            <vs-col vs-type="flex" vs-w="2" vs-justify="center" v-if="$isCenterBranch()">
          <span v-if="entry.originQuantity - entry.currentLeft != 0"
                class="w-full weight-600 pl-2 text-smaller text-center"
                :class="{'text-success' : entry.currentLeft - entry.originQuantity > 0, 'text-danger' : entry.currentLeft - entry.originQuantity < 0}">
            {{
              (entry.currentLeft - entry.originQuantity > 0 ? '+' : '') + (entry.currentLeft - entry.originQuantity).toFixed(2)
            }}
          </span>
              <feather-icon v-else icon='CheckIcon' svgClasses='h-4 w-4' class='ml-1 text-success'/>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
import {
  createNewTransfer,
  getTransferForCreate,
  getEmptyStocksExcel
} from "@/api/MonthlyStockTransfer";
import {getStockTransferStatuses} from "@/model/constants/stockTransferStatuses";

export default {
  data() {
    return {
      stockTransferStatuses: getStockTransferStatuses(),
      isUpdateConfirmActive: false,
      newListWithStocks: [],
      filteredList: [],
      hasWaitingForApprove: null,
      transferId: null,
      date: null,
      isActive: false,
      isFilterOpen: false,
      stockNameFilter: ""
    }
  },
  methods: {
    getEmptyStocksExcel() {
      getEmptyStocksExcel().then(res => {
        if (res && res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Boş Stok Transfer.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    setFilter: _.debounce(function (val) {
      // this.isShow = false;
      this.filteredList = this.newListWithStocks.filter(function (str) {
        return str.stock.rawMaterial.name.toLocaleLowerCase('tr-TR').includes(val.toLocaleLowerCase('tr-TR'))
      })
    }, 1000),
    resetValues() {
      this.date = null;
      this.transferId = null;
      this.hasWaitingForApprove = null;
      this.newListWithStocks = [];
      this.isUpdateConfirmActive = false;
    },
    escapeSubmit() {
      if (this.isUpdateConfirmActive == true) this.isUpdateConfirmActive = false;
    },
    escape() {
      if (this.isActive) this.isActive = false;
    },
    submitData: async function (isConfirmed) {
      if (!isConfirmed) {
        this.isUpdateConfirmActive = true;
        return
      }
      let checker = await this.$validator.validateAll();
      if (checker) {
        this.newListWithStocks.forEach(x => {
          if (x.currentLeft) x.currentLeft = parseFloat(x.currentLeft)
          else x.currentLeft = 0;
          x.originQuantity = parseFloat(x.originQuantity);
        })
        createNewTransfer(this.newListWithStocks).then(res => {
          if (res && res.status == 200) {
            if (res.data.status == 2) {
              this.hasWaitingForApprove = true;
            }
            this.transferId = res.data.id;
            this.date = res.data.created;
            this.$vs.notify({
              color: "success",
              title: "Devir İşlemi",
              text: "Stok Devir İşlemi Başarılı !"
            });
            this.isActive = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Devir İşlemi Başarısız !"
            });
          }
        }).catch(error => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      }
    },
    getTransferForCreate() {
      getTransferForCreate().then(res => {
        if (res && res.status == 200) {
          this.hasWaitingForApprove = res.data.hasWaitingForApprove;
          this.date = res.data.created;
          this.newListWithStocks = [];
          res.data.entries.forEach(entry => {
            this.newListWithStocks.push({
              stock: entry.stock,
              currentLeft: entry.currentLeft,
              originQuantity: entry.originQuantity
            });
          });
          this.filteredList = this.newListWithStocks
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Stok Listesi Yüklenemedi !'
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Listeleme İşlemi Başarısız !',
          text: 'Sunucu Bağlantı Hatası'
        });
      });
    }
  },
  computed: {
    day() {
      return this.$now.date().getDate();
    },
    year() {
      return this.$now.date().getFullYear();
    },
    month() {
      let month = this.$now.date().getMonth() + 1;
      return this.$months().find(x => x.id === month);
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        this.getTransferForCreate();
      }
    }
  }
}

</script>

<style>
#newTransfer {
  height: calc(100vh - 200px);
  overflow-y: auto;
}

#newTransferEntry {
  border-bottom: .5px solid #00000040;
}

#newStockTransferModal .vs-popup--content {
  overflow: hidden;
}

</style>
